import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  authenticate() {
    const authUrl = new URL('/auth/discord', window.location.origin);
    authUrl.searchParams.append('redirect_to_spring', 'true');
    window.location.href = authUrl.toString();
  }
}
